import React from "react";
import { Users } from "lucide-react";
import { usePresence } from "../game/presence";

// Live concurrent-player badge. `active` toggles whether THIS user
// participates in the count (heartbeat). Use active=true while the user is
// in a real game session, active=false on the menu (we only DISPLAY the
// number there).
//
// When the count can't be loaded (backend down, offline), we fall back to
// "1 player online" so the UI still feels alive.
export default function PlayerCountBadge({ active = false, variant = "menu" }) {
  const count = usePresence(active);
  const displayed = count == null ? 1 : count;
  const isMini = variant === "mini";
  return (
    <div
      className={`presence-badge ${isMini ? "presence-mini" : "presence-menu"}`}
      data-testid="presence-badge"
      aria-live="polite"
    >
      <span className="presence-dot" aria-hidden="true" />
      <Users size={isMini ? 13 : 16} strokeWidth={2.2} />
      <span className="presence-count" data-testid="presence-count">
        {displayed}
      </span>
      <span className="presence-label">{displayed === 1 ? "player" : "players"} online</span>
    </div>
  );
}
